import { User } from '@pletly/shared';
import { useSearch } from '@pletly/ui';

export const useMemberSearch = <Member extends User>({ data }: { data: Member[] }) => {
	return useSearch({
		data,
		searchColumns: ['firstName', 'lastName', 'username'],
	});
};
